/**
 * Related Products Modal — quick add to cart from drawer.
 */
import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

class RelatedProductsDrawer {
  constructor() {
    this.#init();
  }

  #init() {
    // Délégation sur document : le module ne s'exécute qu'une fois, alors que le drawer
    // est remplacé à chaque navigation douce (page-transitions).
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#related-products-drawer [data-add-related]');
      if (!btn) return;
      this.#addToCart(btn);
    });
  }

  async #addToCart(btn) {
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId || btn.classList.contains('is-loading')) return;

    const label = btn.querySelector('.cta-link__text') || btn;
    const original = btn.dataset.label || label.textContent;

    // Loading state: mute the colour and swap in the "adding" text.
    btn.classList.add('is-loading');
    label.textContent = btn.dataset.addingLabel || original;

    const reset = () => {
      label.textContent = original;
      btn.classList.remove('is-loading');
    };

    try {
      const cartDrawer = document.querySelector('cart-drawer-component');
      const sectionId = cartDrawer?.dataset.sectionId || '';

      const body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionId,
        sections_url: window.location.pathname,
      });

      const res = await fetch(Theme.routes.cart_add_url, fetchConfig('json', { body }));
      const data = await res.json();

      if (!res.ok || data.errors) {
        reset();
        return;
      }

      document.dispatchEvent(
        new CartAddEvent(data, null, {
          sections: data.sections,
          source: 'related-products-modal',
        })
      );

      reset();
    } catch (err) {
      console.error('Related products add error:', err);
      reset();
    }
  }
}

new RelatedProductsDrawer();
